import { FileExtensions } from './file-extensions';

export const WebThreeDPreviewFileExtensions = [FileExtensions.stl, FileExtensions.obj, FileExtensions.ply] as const;

export function isWebThreeDPreviewFileExtension(fileExtension?: string | null): boolean {
    const normalizedFileExtension = fileExtension?.trim().toLowerCase();

    return WebThreeDPreviewFileExtensions.includes(
        normalizedFileExtension as (typeof WebThreeDPreviewFileExtensions)[number]
    );
}

export function isWebThreeDPreviewFile(file: { fileExtension?: string | null }): boolean {
    return isWebThreeDPreviewFileExtension(file.fileExtension);
}
